import React from 'react';
import './cart-other-details.scss';
import { SVGS } from '../../../assets';
import { TouchableOpacity } from '../../../common';

type ItemConfig = {
  key: string;
  label: string;
  required?: boolean;
  icon?: string;
};

export const TextFieldComp: React.FC<{
  item: ItemConfig;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onLocationClick?: () => void;
  disabled?: boolean;
}> = ({ item, value, onChange, onLocationClick, disabled = false }) => {
  return (
    <div>
      <div className="other-details-sub-view-label">
        <span className="other-details-sub-view-lable-text font-semibold">
          {item.label}
        </span>
        {item.required && (
          <span className="other-details-info-required">*</span>
        )}
      </div>

      <div
        className="other-details-input-wrapper"
        style={{ opacity: disabled ? 0.6 : 1 }}
      >
        {item.icon && (
          <>
            <img src={item.icon} className="input-icon-view" />
            <div className="input-divider-view" />
          </>
        )}
        <input
          type="text"
          placeholder={`Enter ${item.label}`}
          value={value}
          onChange={onChange}
          className="other-details-input-wrapper--text-input font-regular"
          disabled={disabled}
        />
      </div>
      {!disabled && item?.key === 'location' && (
        <div className="other-details-location-view">
          <img src={SVGS.InputInfo} />
          <span className="other-details-location-view-text font-regular">
            {'Find location in maps.'}
          </span>
          <TouchableOpacity onPress={() => onLocationClick?.()}>
            <span className="other-details-location-view-text click-text font-regular">{`click here`}</span>
          </TouchableOpacity>
        </div>
      )}
    </div>
  );
};
